module.exports = __webpack_public_path__ + "static/media/streak.83336c99.svg";